/**
 * Created by Damian on 2017-11-03.
 */

export default class ACEF {

  addText(conf){
    if ( !conf )
    {
      conf = {"id":"Open Sans","font":"","type":"text","text":"example text..."};
    }
    $(window).trigger('MediaManager-addLayer', conf);
  }

}